/*
  NordicVend: FAQ-delens skript (produkt, artikel och kollektion) (snippets/NV-FAQ.liquid).
  Låg tidigare inline i snippeten. Som egen fil cachas den mellan sidvisningar.
  Laddas med defer från snippeten. Värden från Liquid läses från skripttaggens
  data-attribut (document.currentScript), så filen innehåller ingen Liquid.
*/
  (function () {
    var NV_FAQ_SCRIPT = document.currentScript;
    var MODE = NV_FAQ_SCRIPT.getAttribute('data-mode') || '';
    var MOUNT_ID = NV_FAQ_SCRIPT.getAttribute('data-mount') || '';

    /* Gemensamt dragspel for alla lagen.
       Markup: h3.nv-faq__q > button.nv-faq__question, svaret i .nv-faq__answer.
       Stängda svar är inert, så att länkar i dem inte går att tabba till. */
    var svarNr = 0;
    function setOpen(item, open) {
      var btn = item.querySelector('.nv-faq__question');
      var ans = item.querySelector('.nv-faq__answer');
      item.classList.toggle('is-open', open);
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (ans) {
        if (open) ans.removeAttribute('inert');
        else ans.setAttribute('inert', '');
      }
    }
    function bindAccordion(root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('.nv-faq__item'));
      items.forEach(function (item) {
        var btn = item.querySelector('.nv-faq__question');
        if (!btn || btn.dataset.nvFaqBound === 'true') return;
        btn.dataset.nvFaqBound = 'true';
        var ans = item.querySelector('.nv-faq__answer');
        if (ans) {
          if (!ans.id) ans.id = 'nv-faq-svar-js-' + (++svarNr);
          btn.setAttribute('aria-controls', ans.id);
        }
        setOpen(item, item.classList.contains('is-open'));
        btn.addEventListener('click', function () {
          setOpen(item, !item.classList.contains('is-open'));
        });
      });
      return items;
    }

    /* Frågan som rubrik med knappen inuti (en rubrik får inte ligga i en knapp) */
    function buildQuestion(text, id) {
      var h = document.createElement('h3');
      h.className = 'nv-faq__q';
      if (id) h.id = id;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nv-faq__question';
      btn.setAttribute('aria-expanded', 'false');
      var t = document.createElement('span');
      t.className = 'nv-faq__q-text';
      t.textContent = text;
      var icon = document.createElement('span');
      icon.className = 'nv-faq__icon';
      icon.setAttribute('aria-hidden', 'true');
      btn.appendChild(t);
      btn.appendChild(icon);
      h.appendChild(btn);
      return h;
    }

    /* Produktlaget: åtta fasta frågor, sökrutan byter ut dem mot de åtta som passar bäst */
    function initStatic() {
      var root = document.querySelector('[data-nv-faq-product]');
      if (!root || root.dataset.nvFaqInit === 'true') return;
      root.dataset.nvFaqInit = 'true';

      var list = root.querySelector('.nv-faq__items');
      var input = root.querySelector('.nv-faq__search-input');
      var status = root.querySelector('.nv-faq__search-status');
      var defaults = bindAccordion(root);
      if (!list || !input) return;

      var MAX = 8;
      /* En egen liten mall (templates/page.nv-fq-data.liquid) med bara frågorna.
         Fungerar den inte läses hela sidan i stället. */
      var POOL_URLS = ['/pages/vanliga-fragor?view=nv-fq-data', '/pages/vanliga-fragor'];
      var CACHE_KEY = 'nvFaqPool:v6';

      /* Ord som inte säger något om vad man letar efter */
      var STOP = ' jag du ni vi en ett och att det den de ar pa i till for med om kan hur vad var nar min mitt mina man har som av eller ska far finns tar ta gor blir nagon nagot nagra sa inte alla era er ';
      /* Ord kunder skriver, och vad de brukar mena */
      var SYN = {
        frakt: ['leverans', 'levererar', 'skickas'],
        leverans: ['levereras', 'snabbt', 'frakt', 'skickas', 'levererar'],
        snabbt: ['leverans', 'express', 'snabbare'],
        levereras: ['leverans', 'levererar', 'pall'],
        eluttag: ['installeras', 'installation'],
        el: ['eluttag', 'installeras'],
        leveranstid: ['snabbt', 'leverans', 'skickas'],
        skicka: ['leverans', 'skickas'],
        faktura: ['fakturaunderlag', 'two', 'betala'],
        fakturakop: ['faktura', 'two'],
        betala: ['betalning', 'faktura', 'klarna', 'swish'],
        betalning: ['betala', 'faktura', 'klarna', 'swish'],
        delbetalning: ['delbetala', 'two', 'klarna'],
        avbetalning: ['delbetalning', 'two', 'klarna'],
        retur: ['returnera', 'angra', 'angerratt'],
        returnera: ['retur', 'angra', 'angerratt'],
        angra: ['angerratt', 'retur', 'avbestalla'],
        angerratt: ['angra', 'retur'],
        trasig: ['skadad', 'reklamera', 'garanti', 'fel'],
        sonder: ['skadad', 'reklamera', 'garanti'],
        fungerar: ['reklamera', 'garanti', 'fel'],
        skada: ['skadad', 'transportskada', 'reklamera'],
        skadad: ['skada', 'transportskada', 'reklamera'],
        garanti: ['trygghetsgaranti', 'reklamera'],
        pris: ['kostar', 'kostnad', 'avgift'],
        kostar: ['kostnad', 'avgift', 'pris'],
        kostnad: ['kostar', 'avgift'],
        avgift: ['avgifter', 'kostnad', 'kostar'],
        installera: ['installerar', 'installation'],
        installation: ['installerar', 'installera'],
        montera: ['installerar', 'installation'],
        reservdel: ['reservdelar', 'service'],
        matt: ['plats', 'dorrbredder'],
        storlek: ['plats', 'matt'],
        plats: ['matt', 'dorrbredder'],
        offert: ['storre'],
        sparning: ['spara', 'sparningssida'],
        spara: ['sparningssida'],
        kvitto: ['fakturaunderlag'],
        konto: ['logga'],
        foretag: ['foretagsfaktura']
      };

      function norm(t) {
        return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, ' ').trim();
      }
      function words(t) { return t ? t.split(' ') : []; }

      /* kw: extra sökord (data-sokord på de åtta fasta frågorna), räknas som frågetext */
      /* Texten tas ur ett eget, inert dokument, så att bilder i svaren inte laddas */
      var parser = typeof DOMParser !== 'undefined' ? new DOMParser() : null;
      function textOf(html) {
        if (parser) {
          var doc = parser.parseFromString(html || '', 'text/html');
          return doc.body ? doc.body.textContent : '';
        }
        var tpl = document.createElement('template');
        tpl.innerHTML = html || '';
        return tpl.content.textContent;
      }
      function makeEntry(q, html, cat, kw) {
        var nq = norm(q);
        var na = norm(textOf(html));
        return { q: q, html: html, key: nq, qw: words(norm(q + ' ' + (kw || ''))), aw: words(na), cw: words(norm(cat)) };
      }

      /* Standardfrågorna finns alltid, även innan resten hämtats */
      var pool = defaults.map(function (el) {
        var q = el.querySelector('.nv-faq__q');
        var c = el.querySelector('.nv-faq__answer-content');
        return makeEntry(q ? q.textContent.trim() : '', c ? c.innerHTML.trim() : '', el.getAttribute('data-kategori') || '', el.getAttribute('data-sokord') || '');
      });

      function addToPool(raw) {
        var seen = {};
        pool.forEach(function (e) { seen[e.key] = e; });
        raw.forEach(function (r) {
          var e = makeEntry(r.q, r.a, r.c);
          /* Finns frågan redan bland de åtta fasta vinner den fasta versionen */
          if (!e.key || seen[e.key]) return;
          seen[e.key] = e;
          pool.push(e);
        });
      }

      /* Ett avstånd på en bokstav (två för långa ord) räknas som stavfel */
      function near(a, b) {
        var la = a.length, lb = b.length;
        var max = la >= 8 ? 2 : 1;
        if (la < 5 || Math.abs(la - lb) > max) return false;
        var prev = [], cur, i, j;
        for (j = 0; j <= lb; j++) prev[j] = j;
        for (i = 1; i <= la; i++) {
          cur = [i];
          var rowMin = i;
          for (j = 1; j <= lb; j++) {
            cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
            if (cur[j] < rowMin) rowMin = cur[j];
          }
          if (rowMin > max) return false;
          prev = cur;
        }
        return prev[lb] <= max;
      }

      /* Hur bra ett sökord passar en lista med ord: 4 exakt ord, 3 början på ordet, 2 böjning, 1 stavfel */
      function hit(token, list) {
        var best = 0;
        for (var i = 0; i < list.length; i++) {
          var w = list[i];
          if (w === token) return 4;
          if (best < 3 && w.indexOf(token) === 0) { best = 3; continue; }
          if (best < 2 && token.length >= 5 && w.length >= 4 && token.indexOf(w) === 0 && token.length - w.length <= 3) best = 2;
          else if (best < 2 && token.length >= 4 && w.indexOf(token) > 0) best = 2;
          else if (best < 1 && near(token, w)) best = 1;
        }
        return best;
      }

      function score(e, tokens, phrase) {
        var total = 0, matched = 0;
        tokens.forEach(function (t) {
          var s = hit(t, e.qw) * 3 + hit(t, e.cw) + hit(t, e.aw);
          (SYN[t] || []).forEach(function (syn) {
            var ss = (hit(syn, e.qw) * 3 + hit(syn, e.cw) + hit(syn, e.aw)) * 0.5;
            if (ss > s) s = ss;
          });
          if (s > 0) { matched++; total += s; }
        });
        if (!matched) return 0;
        if (matched === tokens.length) total += 6;
        if (phrase.length > 3 && e.key.indexOf(phrase) !== -1) total += 10;
        return total;
      }

      function buildItem(e) {
        var item = document.createElement('div');
        item.className = 'nv-faq__item';
        var ans = document.createElement('div');
        ans.className = 'nv-faq__answer';
        ans.innerHTML = '<div class="nv-faq__answer-inner"><div class="nv-faq__answer-content"></div></div>';
        ans.querySelector('.nv-faq__answer-content').innerHTML = e.html;
        item.appendChild(buildQuestion(e.q));
        item.appendChild(ans);
        return item;
      }

      function show(nodes) {
        list.classList.remove('is-swapped');
        while (list.firstChild) list.removeChild(list.firstChild);
        nodes.forEach(function (n) { list.appendChild(n); });
        void list.offsetWidth;
        list.classList.add('is-swapped');
        bindAccordion(list);
      }

      var lastQuery = '';
      function run() {
        var phrase = norm(input.value);
        if (phrase === lastQuery) return;
        lastQuery = phrase;

        if (!phrase) {
          defaults.forEach(function (el) { setOpen(el, false); });
          show(defaults);
          status.innerHTML = '';
          return;
        }

        var tokens = words(phrase).filter(function (t) { return t.length >= 2 && STOP.indexOf(' ' + t + ' ') === -1; });
        if (!tokens.length) tokens = words(phrase);

        var ranked = pool.map(function (e, i) { return { e: e, s: score(e, tokens, phrase), i: i }; })
          .filter(function (r) { return r.s > 0; })
          .sort(function (a, b) { return b.s - a.s || a.i - b.i; });
        /* Träffar som bara nämner ordet i förbigående tas bort när det finns bättre */
        if (ranked.length) {
          var floor = ranked[0].s * 0.3;
          ranked = ranked.filter(function (r) { return r.s >= floor; });
        }

        if (!ranked.length) {
          show([]);
          status.innerHTML = 'Inga frågor matchar din sökning. <a href="/pages/kontakta-oss">Kontakta oss</a>, så hjälper vi dig.';
          return;
        }
        show(ranked.slice(0, MAX).map(function (r) { return buildItem(r.e); }));
        if (ranked.length > MAX) {
          status.innerHTML = 'Här är de ' + MAX + ' frågor som passar bäst. Fler svar finns på sidan <a href="/pages/vanliga-fragor">Vanliga frågor</a>.';
        } else if (ranked.length === 1) {
          status.innerHTML = '1 fråga matchar din sökning.';
        } else {
          status.innerHTML = ranked.length + ' frågor matchar din sökning.';
        }
      }

      var timer = null;
      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(run, 120);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          input.value = '';
          run();
        } else if (e.key === 'Enter') {
          /* Stänger tangentbordet på mobilen så att svaren syns */
          e.preventDefault();
          clearTimeout(timer);
          run();
          input.blur();
        }
      });

      /* Alla frågor från /pages/vanliga-fragor, hämtas en gång när de behövs */
      var loading = false;
      /* Söker man redan, visa de nya träffarna. Annars rörs listan inte,
         så en fråga man har öppnat stängs inte när hämtningen blir klar. */
      function rerunIfSearching() {
        if (!norm(input.value)) return;
        lastQuery = null;
        run();
      }
      function loadPool() {
        if (loading) return;
        loading = true;
        try {
          var cached = sessionStorage.getItem(CACHE_KEY);
          if (cached) {
            addToPool(JSON.parse(cached));
            rerunIfSearching();
            return;
          }
        } catch (e) {}
        if (!window.fetch || !window.DOMParser) return;
        function parse(html) {
            var doc = new DOMParser().parseFromString(html || '', 'text/html');
            var raw = [];
            doc.querySelectorAll('.nv-fq-card').forEach(function (card) {
              var q = card.querySelector('.nv-fq-q h3');
              var body = card.querySelector('.nv-fq-body');
              var block = card.closest('.nv-fq-block');
              var cat = block && block.querySelector('h2');
              if (!q || !body) return;
              raw.push({ q: q.textContent.trim(), a: body.innerHTML.trim(), c: cat ? cat.textContent.trim() : '' });
            });
            return raw;
        }
        /* Provar adresserna i tur och ordning tills någon ger frågor */
        function tryUrl(i) {
          if (i >= POOL_URLS.length) return;
          fetch(POOL_URLS[i], { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (html) {
              var raw = parse(html);
              if (!raw.length) { tryUrl(i + 1); return; }
              try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(raw)); } catch (e) {}
              addToPool(raw);
              rerunIfSearching();
            })
            .catch(function () { tryUrl(i + 1); });
        }
        tryUrl(0);
      }

      input.addEventListener('focus', loadPool, { once: true });
      input.addEventListener('pointerdown', loadPool, { once: true });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          if ('requestIdleCallback' in window) requestIdleCallback(loadPool, { timeout: 2000 });
          else setTimeout(loadPool, 300);
        }, { rootMargin: '600px 0px' });
        io.observe(root);
      }
    }

    /* Artikel och kollektion: bygg dragspel av befintlig text */
    function normalizeText(text) {
      return (text || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function looksLikeFaqHeading(text) {
      var t = normalizeText(text);
      return (
        t.indexOf('vanliga fragor') > -1 ||
        t.indexOf('vanlig fragor') > -1 ||
        t.indexOf('vanloiga fragor') > -1 ||
        t.indexOf('fragor och svar') > -1 ||
        t === 'faq'
      );
    }

    function isHeading(el) {
      return !!(el && el.tagName && /^H[1-6]$/.test(el.tagName));
    }

    function isQuestionHeading(el) {
      if (!isHeading(el)) return false;
      if ((el.textContent || '').indexOf('?') === -1) return false;
      /* Frågorna är alltid H3. En H2 med frågetecken är en egen rubrik i
         innehållsförteckningen och ska stå kvar. */
      return el.tagName === 'H3';
    }

    function findSource() {
      var mount = document.getElementById(MOUNT_ID);
      if (!mount || mount.dataset.nvFaqInit === 'true') return null;

      var containers;
      if (MODE === 'collection') {
        containers = [
          document.querySelector('.collection--description.rte'),
          document.getElementById('custom-collection-text'),
          document.getElementById('custom-html-collection-text')
        ].filter(Boolean);
      } else {
        containers = [
          mount.closest('.article-template, .article, .rte, .article-content'),
          document.querySelector('.article-template .rte, .article .rte, .rte')
        ].filter(Boolean);
      }

      var found = null;
      containers.some(function (container) {
        var headings = Array.prototype.slice.call(container.querySelectorAll('h1, h2, h3, h4, h5, h6'));
        var heading = headings.find(function (h) {
          return looksLikeFaqHeading(h.textContent);
        });
        if (heading) {
          found = { mount: mount, container: container, heading: heading };
          return true;
        }
        return false;
      });
      return found;
    }

    function initInline() {
      var source = findSource();
      if (!source) return false;

      var faqStart = source.heading;
      var wrap = document.createElement('div');
      wrap.className = 'nv-faq nv-faq--inline';

      var list = document.createElement('div');
      list.className = 'nv-faq__items';

      var current = faqStart.nextElementSibling;
      var foundAny = false;
      var nodesToRemove = [];

      while (current) {
        if (isHeading(current) && !isQuestionHeading(current)) break;

        if (isQuestionHeading(current)) {
          foundAny = true;

          var questionEl = current;
          var answerNodes = [];
          var walker = current.nextElementSibling;

          while (walker) {
            if (isHeading(walker)) break;
            answerNodes.push(walker);
            walker = walker.nextElementSibling;
          }

          var answerHtml = '';
          answerNodes.forEach(function (node) {
            answerHtml += node.outerHTML;
          });

          var item = document.createElement('div');
          item.className = 'nv-faq__item';

          /* Rubrikens id följer med, så att ankarlänkar till frågan fungerar */
          var title = buildQuestion(questionEl.textContent.trim(), questionEl.id);

          var answer = document.createElement('div');
          answer.className = 'nv-faq__answer';

          var answerInner = document.createElement('div');
          answerInner.className = 'nv-faq__answer-inner';

          var answerContent = document.createElement('div');
          answerContent.className = 'nv-faq__answer-content';
          answerContent.innerHTML = answerHtml;

          answerInner.appendChild(answerContent);
          answer.appendChild(answerInner);
          item.appendChild(title);
          item.appendChild(answer);
          list.appendChild(item);

          nodesToRemove.push(questionEl);
          answerNodes.forEach(function (node) {
            nodesToRemove.push(node);
          });

          current = walker;
          continue;
        }

        current = current.nextElementSibling;
      }

      if (!foundAny) return false;

      source.mount.dataset.nvFaqInit = 'true';
      wrap.appendChild(list);
      faqStart.parentNode.insertBefore(wrap, faqStart.nextSibling);

      nodesToRemove.forEach(function (node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
      });

      bindAccordion(wrap);
      return true;
    }

    function init() {
      if (MODE === 'product') {
        initStatic();
        return;
      }
      if (!initInline()) {
        /* Artikelinnehall kan komma in sent, forsok igen efter load */
        window.addEventListener('load', initInline, { once: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
